import { createContext, useContext, useState, useEffect } from 'react';
import { translations, languages } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('nephrix-lang');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('nephrix-lang', currentLang);
  }, [currentLang]);

  const t = (key) => {
    return translations[currentLang]?.[key] || translations['en']?.[key] || key;
  };

  const switchLanguage = (langCode) => {
    setCurrentLang(langCode);
  };

  return (
    <LanguageContext.Provider value={{ currentLang, t, switchLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
